/** Unmistakable, and never reached by accident: it takes a second press. */

import { useEffect, useRef, useState, type CSSProperties } from "react";

import { cn } from "@/lib/cn";

import "./PanicButton.css";

const ARMED_MS = 4000;

export interface PanicButtonProps {
  readonly onConfirm: () => void;
  readonly label: string;
  /** The second press, once armed. */
  readonly confirmLabel?: string;
  readonly disabled?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function PanicButton({
  onConfirm,
  label,
  confirmLabel = "Press again",
  disabled = false,
  className,
  style,
}: PanicButtonProps) {
  const [armed, setArmed] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const press = () => {
    if (armed) {
      window.clearTimeout(timer.current);
      setArmed(false);
      onConfirm();
      return;
    }
    setArmed(true);
    timer.current = window.setTimeout(() => setArmed(false), ARMED_MS);
  };

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={press}
      style={style}
      aria-live="polite"
      className={cn("al-panic", armed ? "al-panic-armed" : undefined, className)}
    >
      {armed ? confirmLabel : label}
    </button>
  );
}
